import { createFileRoute } from '@tanstack/react-router'

import PagePocRecipeNew from '@/pages/PagePocRecipeNew'

export const Route = createFileRoute('/poc/recipe-generator/')({
  component: PagePocRecipeNew
})
